import { FC, useEffect, useState } from "react";
import { connect, ConnectedProps, useDispatch } from "react-redux";
import { IGlobalReducerState } from "Store/Base/interface/IGlobalReducerState";
import PageHeader from "Components/UI/PageHeader/PageHeader";
import TableActionTopbar, { ITableActionTopbarButton } from "Components/UI/TableActionTopbar";
import { AdmActions } from "Store/Adm/Adm.actions";
import DeleteForm from "./Modals/DeleteForm";
import CreateForm from "./Modals/CreateForm";
import Library from "./components/Library";
import { IConstructionSiteDisciplineLibrary } from "Data/interfaces/Obra/IDisciplineLibraries";
import { TableWrapper } from "./styles";

const Disciplinas: FC<Props> = ({
  disciplineLibraries,
  listDisciplineLibrariesLoading,
  isLoading,
}) => {
  const dispatch = useDispatch();

  const [libEdit, setLibEdit] = useState<IConstructionSiteDisciplineLibrary | null>(null);
  const [showCreateOrUpdateLibModal, setShowCreateOrUpdateLibModal] = useState(false);
  const [showDeleteLibModal, setShowDeleteLibModal] = useState(false);

  const getActionsToolbar = (): ITableActionTopbarButton[] => {
    return [
      {
        icon: 'arquivar',
        description: 'Criar Biblioteca',
        action: newLib,
      },
    ];
  };

  const newLib = () => {
    setShowCreateOrUpdateLibModal(true);
  }

  const updateLib = (lib: IConstructionSiteDisciplineLibrary) => {
    setLibEdit(lib)
    setShowCreateOrUpdateLibModal(true);
  }

  const deleteLib = (lib: IConstructionSiteDisciplineLibrary) => {
    setLibEdit(lib)
    setShowDeleteLibModal(true);
  }

  const closeModal = () => {
    setLibEdit(null);
    setShowCreateOrUpdateLibModal(false);
    setShowDeleteLibModal(false);
  }

  useEffect(() => {
    dispatch(AdmActions.listDisciplineLibrary());
  }, []);

  return (
    <>
      <PageHeader name="Controle de Disciplinas" />

      <TableWrapper>
        <TableActionTopbar buttons={getActionsToolbar()} />
        <Library
          libraries={disciplineLibraries}
          loading={isLoading}
          listLoading={listDisciplineLibrariesLoading}
          onOpen={updateLib}
          onDelete={deleteLib}
        />
      </TableWrapper>

      {showCreateOrUpdateLibModal && (
        <CreateForm
          visible={showCreateOrUpdateLibModal}
          editLib={libEdit}
          onClose={closeModal}
        />
      )}

      {showDeleteLibModal && libEdit && (
        <DeleteForm
          visible={showDeleteLibModal}
          isLoading={isLoading}
          deleteLib={libEdit}
          onCancel={closeModal}
        />
      )}
    </>
  )
}

const mapState = (state: IGlobalReducerState) => ({
  ...state.adm
});

const connector = connect(mapState);

type PropsFromRedux = ConnectedProps<typeof connector>;
type Props = PropsFromRedux;

export default connector(Disciplinas);
